import "./ViewUploadedMenu.scss";

function ViewUploadedMenu(props: { array: string[], tabValue: number, tabValueHandler: CallableFunction }) {

  return (
    <div className="tab-view-container">
      {props.array.map((menu: any, index: number) => {
        return (
          <div key={index} className={props.tabValue === index ? "tab second active" : "tab second"}
            onClick={() => { props.tabValueHandler(index); }}>
            {menu}
          </div>
        );
      })}
    </div>
  );
}

export default ViewUploadedMenu;
